import React, { useState } from 'react';
import { TrialRequestFormFields } from './trial-request-form-fields';
import { validationSchema } from './validation-schema';
import FormInput from '../../../shared/components/forms/FormInput';
import { TrialRequestFormData } from './trial-request-form-data';
import Form from '../../../shared/components/forms/Form';
import FormGroup from '../../../shared/components/forms/FormGroup';
import { ColorScheme } from '../../../shared/enums/ColorScheme';
import ButtonSubmit from '../../../shared/components/forms/ButtonSubmit';
import { Link } from 'react-router-dom';
import { RoutePath } from '../../../shared/enums/RoutePath';
import { RequestEmailService } from '../request-email.service';
import ApiContactService from '../../../shared/api/ContactApiService';
import { SubmitFormFn } from '../../../shared/components/forms/types/SubmitFormFn';
import { ControlSize } from '../../../shared/enums/ControlSize';
import { AlignTypesHorizontal } from '../../../shared/enums/AlignTypesHorizontal';
import { TrialRequestTextElement } from './enum/TrialRequestTextElement';
import { useLocation } from 'react-router-dom';
import { executeRecaptcha } from '../../../shared/services/recaptchaEnterpriseService';

const RequestForm: React.FC = () => {
  const email: string | undefined = RequestEmailService.extractValue();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const linkSource = queryParams.get('utm_source') ?? '';
  const defaultValues: Partial<TrialRequestFormData> = {
    [TrialRequestFormFields.BusinessEmail]: email,
  };

  const [isSubmitted, setIsSubmitted] = useState(false);
  const onSubmit: SubmitFormFn<TrialRequestFormData> = async data => {
    const recaptchaToken = await executeRecaptcha('trial_request_submit');

    const dataWithLinkSource = {
      ...data,
      [TrialRequestFormFields.Captcha]: recaptchaToken,
      [TrialRequestFormFields.LinkSource]: linkSource,
    };
    return ApiContactService.requestTrialRequest(dataWithLinkSource).then(() => setIsSubmitted(true));
  };

  return (
    <div className="TrialRequestForm">
      <Form
        defaultValues={defaultValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        size={ControlSize.LargerLarge}
      >
        <FormGroup>
          <FormInput
            name={TrialRequestFormFields.FirstName}
            label="First Name"
            placeholder="First Name"
            isDisabled={isSubmitted}
          />
        </FormGroup>

        <FormGroup>
          <FormInput
            name={TrialRequestFormFields.LastName}
            label="Last Name"
            placeholder="Last Name"
            isDisabled={isSubmitted}
          />
        </FormGroup>

        <FormGroup>
          <FormInput
            name={TrialRequestFormFields.PhoneNumber}
            label="Phone Number"
            placeholder="Phone Number"
            isDisabled={isSubmitted}
          />
        </FormGroup>

        <FormGroup>
          <FormInput
            name={TrialRequestFormFields.BusinessEmail}
            label="Business Email"
            placeholder="Business Email"
            isDisabled={isSubmitted}
          />
        </FormGroup>

        <FormGroup>
          <FormInput
            name={TrialRequestFormFields.Company}
            label="Company"
            placeholder="Company"
            isDisabled={isSubmitted}
          />
        </FormGroup>

        <FormGroup>
          <FormInput
            name={TrialRequestFormFields.JobTitle}
            label="Job Title"
            placeholder="Job Title"
            isDisabled={isSubmitted}
          />
        </FormGroup>

        <FormGroup>
          <ButtonSubmit
            isSubmitted={isSubmitted}
            message="Request Complimentary Access"
            submittedMessage="Your request has been successfully created"
            colorScheme={ColorScheme.Attention}
          />
        </FormGroup>

        <FormGroup>
          <div>You will hear from our team shortly.</div>
          <Link to={RoutePath.Login}>{TrialRequestTextElement.Login}</Link>
        </FormGroup>
      </Form>
    </div>
  );
};

export default RequestForm;
